export default __webpack_public_path__ + "static/media/logo.0e6cd39a.svg";